import React from "react";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from "./components/Header";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import SponsorPage from "./components/SponsorPage";
import UPIPay from "./components/Donate/Upi";
import Paypal from "./components/Donate/Paypal";
import Crypto from "./components/Donate/Crypto/Crypto";
import UserUpi from "./components/Donate/UserUpi/UserUpi";
import Coming from "./components/Coming";

const App = () => {
    return (
        <Router>
            <div className="bg-[#FAF9F6] min-h-screen w-full flex flex-col justify-between text-slate-900">
                <div>
                    <Header />
                    <Routes>
                        <Route path="/upi" element={<UPIPay />} />
                        <Route path="/" element={<SponsorPage />} />
                        <Route path="/paypal" element={<Paypal />} />
                        <Route path="/crypto" element={<Crypto />} />
                        <Route path="/create-upi" element={<UserUpi />} />
                        <Route path="/coming" element={<Coming />} />
                    </Routes>
                </div>
                <div>
                    <Contact />
                    <Footer />
                </div>
            </div>
        </Router>
    );
}

export default App;